import { useStore } from "../context/StoreContext";
import { fmtPrice } from "../lib/api";
import { toast } from "sonner";
import { Package, Check } from "lucide-react";

export const BundleCard = ({ b }) => {
  const { bundleCart, toggleBundle, currency } = useStore();
  const inCart = bundleCart.includes(b.id);

  const add = () => {
    toggleBundle(b.id);
    toast.success(inCart ? "Bundle removed from cart" : `${b.title} added to cart 🎁`);
  };

  return (
    <div className="bundle-card" data-testid={`bundle-card-${b.id}`}>
      <div className="bundle-top">
        <span className="bundle-badge"><Package size={12} /> BUNDLE · SAVE {b.savings_pct}%</span>
        <h3>{b.title}</h3>
        {b.description && <p className="bundle-desc">{b.description}</p>}
      </div>
      <div className="bundle-courses">
        {b.courses.map((c) => (
          <div className="bundle-course" key={c.id}>
            <span className="bc-title">◆ {c.title}</span>
            <span className="bc-price">{fmtPrice(c.effective_price, currency)}</span>
          </div>
        ))}
      </div>
      <div className="bundle-foot">
        <div>
          <span className="bundle-now" data-testid={`bundle-price-${b.id}`}>{fmtPrice(b.price, currency)}</span>
          <span className="bundle-old">{fmtPrice(b.total_value, currency)}</span>
        </div>
        <button className={inCart ? "btn-outline" : "btn-primary"} data-testid={`bundle-add-btn-${b.id}`} onClick={add}>
          {inCart ? <><Check size={14} className="inline mr-1" />IN CART</> : "ADD TO CART"}
        </button>
      </div>
    </div>
  );
};
